import axios from 'axios';
import { ANALYZER_API_URL } from '../constants/api';

const WaterAnalyzerService = {
    async analyze(dateStart, dateEnd) {
        const response = await axios.get(`${ANALYZER_API_URL}/analyze`, {
            params: {
                date_start: dateStart,
                date_end: dateEnd,
            },
        });
        return response.data;
    },
};

export default WaterAnalyzerService;
